/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SensitiveMetric = {
    Profit: 'Profit',
    PurchasePrice: 'PurchasePrice'
} as const;
export type SensitiveMetric = typeof SensitiveMetric[keyof typeof SensitiveMetric];


export function instanceOfSensitiveMetric(value: any): boolean {
    for (const key in SensitiveMetric) {
        if (Object.prototype.hasOwnProperty.call(SensitiveMetric, key)) {
            if (SensitiveMetric[key as keyof typeof SensitiveMetric] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SensitiveMetricFromJSON(json: any): SensitiveMetric {
    return SensitiveMetricFromJSONTyped(json, false);
}

export function SensitiveMetricFromJSONTyped(json: any, ignoreDiscriminator: boolean): SensitiveMetric {
    return json as SensitiveMetric;
}

export function SensitiveMetricToJSON(value?: SensitiveMetric | null): any {
    return value as any;
}

export function SensitiveMetricToJSONTyped(value: any, ignoreDiscriminator: boolean): SensitiveMetric {
    return value as SensitiveMetric;
}

